module.exports = __webpack_public_path__ + "assets/img/get-coach-bg.3483da3d.png";